import { fetcher } from "helpers/fetcher";

import { TGetInactiveVacancyReq, TGetInactiveVacancyRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getInactiveVacancies = async (
  payload?: TGetInactiveVacancyReq
) => {
  return await fetcher<TGetInactiveVacancyRes, TGetInactiveVacancyReq["data"]>(
    ENDPOINT.BU.GET_INACTIVE_VACANCIES,
    {
      data: payload?.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_INACTIVE_VACANCIES.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
    }
  );
};

export const queryGetInactiveVacancies = async (
  params?: TGetInactiveVacancyReq
) => {
  return (await getInactiveVacancies(params)).data;
};

queryGetInactiveVacancies._key = (
  params?: TGetInactiveVacancyReq,
  key?: string
) => [ENDPOINT.BU.GET_INACTIVE_VACANCIES.url, params, key];
